export const metadataPaginationPageDict = {
  en: 'Page',
  de: 'Seite',
  ru: 'Страница',
  tr: 'Sayfa',
  es: 'Página',
};

export const eventsPageMetaDict = {
  en: {
    title: 'Events - Immigrant Invest',
    description:
      'Events and conferences, seminars, and congresses, forums in the field of immigration with the best specialists in this field ➤ Immigrant Invest',
    image: '/images/og/en/events.jpeg',
  },
  ru: {
    title: 'Мероприятия - Иммигрант Инвест',
    description:
      'Мероприятия и конференции, семинары, и конгрессы, форумы в сфере иммиграции с лучшими специалистами в этой сфере ➤ Иммигрант Инвест',
    image: '/images/og/ru/events.jpeg',
  },
};

export const workshopsPageMetaDict = {
  ru: {
    title:
      '[Вебинары] Гражданство за инвестиции в условиях карантина - Иммигрант Инвест',
    description:
      'Живой разбор актуальных вопросов в сфере инвестиционного гражданства в период кризиса',
    image: '',
  },
};

export const videoPageMetaDict = {
  ru: {
    title:
      'Гражданство за инвестиции - Видео-обзоры программ - Immigrant Invest',
    description:
      'Обзоры инввестиционных программ — ВНЖ, ПМЖ и гражданства в странах Европейского союза, Карибах, и Вануату (Океания).',
    image: '',
  },
};
